import { createFileRoute } from "@tanstack/react-router";
import { ClaimPage } from "../features/auth/ClaimPage";

export const Route = createFileRoute("/claim")({
  validateSearch: (s: Record<string, unknown>): { a: string } => ({
    a: typeof s.a === "string" ? s.a : "",
  }),
  component: () => <ClaimPage slug={Route.useSearch().a} />,
});
